export function canShowSmsConsentModal() {
  const dismissDate = localStorage.getItem("dismissSmsConsent");
  if (!dismissDate) {
    return true;
  }
  const month = 1000 * 60 * 60 * 24 * 30; // 1 month

  const data = parseInt(dismissDate);
  const currentTime = new Date().getTime();
  const elapsedTime = currentTime - data;

  return elapsedTime >= month;
}
